import { SortDirection } from '../../../../shared/utils/constants';
import {
  DateFilterLabelState,
  ExcludeWeekendsState,
  TransportReport,
  EndHourState,
  EndState,
  StartHourState,
  StartState,
  TransportsState,
} from '../../../types';

type VisitDetailsDTO = {
  duration: number;
  eventTime: string;
  status: VehicleGeofenceStatus;
};

export type VehicleGeofenceReportItemDTO = {
  id: number;
  name: string;
  visits: VisitDetailsDTO[];
};

type TransportVehicleGeofenceReportDTO = {
  items: VehicleGeofenceReportItemDTO[];
  total: number;
};

export type VehicleGeofenceReportDTO =
  TransportReport<TransportVehicleGeofenceReportDTO>;

export type FormattedVehicleGeofenceReportItemDTO = Omit<
  VehicleGeofenceReportItemDTO,
  'visits' | 'id'
> & {
  duration: number;
  eventTime: string;
  status: VehicleGeofenceStatus;
  geofenceId: number;
  id: string;
  durationFormatted: string;
  eventTimeFormatted: string;
};

export enum VehicleGeofenceStatus {
  ALL = 'ALL',
  ENTERED = 'ENTERED',
  WAS_HERE = 'WAS_HERE',
  LEFT = 'LEFT',
  'NO_RECORD' = 'NO_RECORD',
}

export type GeofencesState = number[];
export type DurationState = number;
export type PenetrationState = number;

export type VehicleGeofenceFiltersState = {
  transports: TransportsState;
  geofences: GeofencesState;
  duration: DurationState;
  penetration: PenetrationState;
  start: StartState;
  end: EndState;
  startHour: StartHourState;
  endHour: EndHourState;
  excludeWeekends: ExcludeWeekendsState;
  dateFilterLabel: DateFilterLabelState;
};

export type VehicleGeofenceFilters = {
  transports: number[];
  geofences: number[];
  duration: number;
  start: string;
  end: string;
  tz: string;
};

export enum VehicleGeofenceReportFilterOption {
  TRANSPORTS = 'transports',
  GEOFENCES = 'geofences',
  DURATION = 'duration',
  PENETRATION = 'penetration',
  EVENT_TYPE = 'eventType',
  START_DATE = 'start',
  END_DATE = 'end',
}

export type VehicleGeofenceReportSortParams = {
  sortBy: 'eventTime' | 'eventType' | 'stayDuration' | 'name';
  sortDirection: SortDirection;
};

export type VehicleGeofenceTotal = {
  [VehicleGeofenceStatus.ALL]: number;
  [VehicleGeofenceStatus.ENTERED]: number;
  [VehicleGeofenceStatus.LEFT]: number;
  [VehicleGeofenceStatus.WAS_HERE]: number;
};

export type VehicleGeofenceReportSlice = {
  isLoading: boolean;
  isFailed: boolean;
  transports: Record<
    number,
    {
      items: FormattedVehicleGeofenceReportItemDTO[];
    }
  >;
};
